export { TeachingPopoverFooter } from './TeachingPopoverFooter';
export { useTeachingPopoverFooter } from './useTeachingPopoverFooter';
export { renderTeachingPopoverFooter } from './renderTeachingPopoverFooter';
export type { TeachingPopoverFooterProps, TeachingPopoverFooterState } from './TeachingPopoverFooter.types';
